<template>
    <NavbarMain/>

    <section class="page-section faq-block">
        <div class="container">
            <div class="faq-grid">
                <!-- Left column: title + intro + contact button -->
                <div class="faq-intro">
                    <h1 v-if="first_section_title_en" class="faq-title" v-safe-html="first_section_title_en"></h1>
                    <h1 v-else class="faq-title">FAQ</h1>
                    <div class="faq-intro-text" v-safe-html="first_section_content_en"></div>
                    <RouterLink to="/contact" class="faq-contact-btn">Contact us</RouterLink>
                </div>

                <!-- Right column: accordion -->
                <div class="faq-accordion">
                    <div v-for="(item, index) in questions" :key="item.id || index" class="faq-item"
                        :class="{ 'is-open': openIndex === index }">
                        <h5 class="faq-question" @click="toggle(index)">
                            <span class="faq-question-text" v-safe-html="item.question"></span>
                            <svg class="faq-chevron" width="22" height="22" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </h5>
                        <div v-show="openIndex === index" class="faq-answer" v-safe-html="item.answer"></div>
                    </div>
                    <p v-if="questions.length === 0" class="faq-empty">No questions available.</p>
                </div>
            </div>
        </div>
    </section>

    <FooterPage/>
</template>

<script>
import axios from 'axios';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';

export default {
    components: {
        NavbarMain,
        FooterPage
    },
    data() {
        return {
            faqData: { items_en: [{}], questions_en: [] },
            openIndex: null,
            first_section_title_en: '',
            first_section_content_en: '',
        }
    },
    computed: {
        questions() {
            const list = this.faqData.questions_en;
            if (!Array.isArray(list)) return [];
            return list.filter(q => q && q.active !== false);
        },
    },
    methods: {
        toggle(index) {
            this.openIndex = this.openIndex === index ? null : index;
        },
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/faq-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.faqData = response.data || { items_en: [], questions_en: [] };

                if (this.faqData.items_en[0]?.active === true) {
                    this.first_section_title_en = this.faqData.items_en[0].first_section_title;
                    this.first_section_content_en = this.faqData.items_en[0].first_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching FAQ data:', error);
            });
    }
}
</script>

<style>
.faq-block {
    padding: 72px 0;
}

.faq-grid {
    display: grid;
    grid-template-columns: 1fr 1.9fr;
    gap: 64px;
    align-items: start;
    text-align: left;
}

@media all and (max-width: 900px) {
    .faq-grid {
        grid-template-columns: 1fr;
        gap: 32px;
    }
}

/* Left column */
.faq-title,
.faq-title p {
    font-size: 42px;
    font-weight: 700;
    color: #111111;
    line-height: 1.15;
    margin: 0 0 20px;
}

.faq-intro-text,
.faq-intro-text p {
    color: #484848;
    font-size: 18px;
    line-height: 1.6;
    margin: 0 0 28px;
}

.faq-contact-btn {
    display: inline-block;
    padding: 14px 40px;
    border: 1px solid #111111;
    border-radius: 999px;
    background-color: #fff;
    color: #111111 !important;
    font-weight: 700;
    text-decoration: none;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.faq-contact-btn:hover {
    background-color: #111111;
    color: #fff !important;
}

/* Accordion */
.faq-accordion .faq-item {
    border-top: 1px solid #e2e2e2;
}

.faq-accordion .faq-item:last-child {
    border-bottom: 1px solid #e2e2e2;
}

.faq-accordion .faq-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    cursor: pointer;
    margin: 0;
    padding: 22px 4px;
    font-size: 20px;
    line-height: 1.35;
}

.faq-accordion .faq-question-text,
.faq-accordion .faq-question-text * {
    color: #111111 !important;
    font-weight: 700;
    margin: 0;
}

.faq-accordion .faq-chevron {
    flex-shrink: 0;
    color: #111111;
    transition: transform 0.2s ease;
}

.faq-accordion .faq-item.is-open .faq-chevron {
    transform: rotate(180deg);
}

/* Open question gets a bordered rounded box */
.faq-accordion .faq-item.is-open .faq-question {
    border: 1px solid #111111;
    border-radius: 10px;
    padding: 20px;
}

.faq-accordion .faq-answer {
    padding: 16px 4px 28px;
}

.faq-accordion .faq-answer,
.faq-accordion .faq-answer p {
    color: #484848;
    font-size: 17px;
    line-height: 1.65;
}

.faq-accordion .faq-answer a {
    color: #111111;
    text-decoration: underline;
}

.faq-empty {
    color: #6E8496;
    font-style: italic;
}
</style>
